import { Font } from '@react-pdf/renderer';

let registered = false;

export const registerFonts = () => {
    if (registered) return;
    registered = true;

    Font.register({
        family: 'Noto Sans Arabic',
        fonts: [
            {
                src: '/assets/fonts/Tajawal/Tajawal-Regular.ttf',
                fontWeight: "normal",
            },
            {
                src: '/assets/fonts/Tajawal/Tajawal-ExtraBold.ttf',
                fontWeight: "bold",
            },
        ]

    });
};